import React, { Fragment } from 'react'
import { PeopleQuery, StateProvider, getHTML, getRichText } from '../../core'

import './expanding-gallery.scss'

const PersonComponent = ({ 
  image = {}, 
  mainContent,
  additionalContent, 
}) => {
  const resize = image.resize || {}

  return (
    <StateProvider>{(isActive, setActive) => {
      const onClick = () => {
        if (window.DEACTIVATE_BIO) {
          window.DEACTIVATE_BIO()
        }

        setActive(!isActive)
        window.DEACTIVATE_BIO = (e) => {
          setActive(false)
        }
      }

      return (
        <div styleName="person" data-is-active={isActive} onClick={onClick}>
          <div 
            styleName="photo"
            style={{ backgroundImage: `url(${resize.src})`}}
          />

          <div styleName="caption">
            {getRichText(mainContent)}
          </div>
  
          <div styleName="bio-wrapper">
            <div styleName="bio original">
              <div styleName="inner">
                {getRichText(additionalContent)}
              </div>
            </div>
            <div styleName="bio copy">
              <div styleName="inner">
                {getRichText(additionalContent)}
              </div>
            </div>
          </div>
        </div>
      )
    }}</StateProvider>
  )
}

const ExpandingGallerySection = ({ data = {}, context = {} }) => {
  const {
    items,
    editableContent,
  } = data

  return (
    <section styleName="team">
      <div styleName="content ">
        {getRichText(editableContent)}
      </div>

      <div styleName="items ">
        {items.map((person, i) => (
          <PersonComponent {...person} key={i} />
        ))}
      </div>
    </section>
  )
}

export default ExpandingGallerySection